"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1749))
 * @lastsynced 2026-10-30T13:50:36.120Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Search = createSVGIcon(
  <path
    d="M16.71 16.71A9.287 9.287 0 1 1 3.577 3.576 9.287 9.287 0 0 1 16.71 16.71Zm0 0 6.433 6.433"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Search",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "BonYS7",
      defaultMessage: "Search",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
